import request from '@/utils/request'
import store from '@/store'

const url = store.getters.getPostUrl;
export default {
  selectAlarmList(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/threshold/page',
      method: 'post',
      data:param
    })
  },
  insert(param) {
  	  return request({
  	    url: store.getters.getPostUrl + 'mes/threshold/insert',
  	    method: 'post',
  	    data:param
  	  })
  },
  update(param) {
  	  return request({
  	    url: store.getters.getPostUrl + 'mes/threshold/update',
  	    method: 'post',
  	    data:param
  	  })
  },
  del(param) {
  	  return request({
  	    url: store.getters.getPostUrl + 'mes /threshold/delete',
  	    method: 'post',
  		params:{'id': param}
  	  })
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/alarm/alarm.js